"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.action('ON_COMMIT_THEME_CHANGE', function (themeId) {
    return {
        themeId: themeId,
    };
});
//# sourceMappingURL=onCommitThemeChange.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/actions/owa-options-actions/lib/onCommitThemeChange.js
// module id = 4959
// module chunks = 2